<template>
  <div>
    <div class="mb10 flex flex-between item-center bgColor p10">
      <div>
        <el-radio-group
          v-model="searchCondition.status"
          size="small"
          @change="switchTab"
        >
          <el-radio-button label="goods">商品明细</el-radio-button>
          <el-radio-button label="tiXian">申报明细</el-radio-button>
          <el-radio-button label="menDian">门店统计</el-radio-button>
          <el-radio-button label="daoGou">导购统计</el-radio-button>
          <el-radio-button label="mingxi">品牌</el-radio-button>
          <el-radio-button label="storeShare">分成明细</el-radio-button>
          <el-radio-button label="refund">退款明细</el-radio-button>
          <!-- <el-radio-button label="jiLu">拦截记录</el-radio-button> -->
          <el-radio-button label="mingxiNew">品牌明细</el-radio-button>
           <el-radio-button label="refundCommodity">商品退款明细</el-radio-button>
        </el-radio-group>
      </div>
      <div>
        当前供货商: <span class="primary">{{ storeNames }}</span>
      </div>
    </div>
    <div
      class="table-panel flex flex-end item-center bgColor"
      style="padding: 0 10px"
    >
      <div style="width: 160px; overflow: hidden">
        <el-select
          style="width: 160px"
          v-if="
            searchCondition.storeOrShopIds &&
            searchCondition.storeOrShopIds.length > 0
          "
          v-model="selectedOptions"
          size="small"
          multiple
          placeholder="所选门店"
        >
          <el-option
            v-for="item in allOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            :disabled="item.disabled"
          >
          </el-option>
        </el-select>
      </div>
      <div
        style="
          color: #e50065;
          font-size: 15px;
          font-weight: 500;
          cursor: pointer;
          margin: 0 20px;
        "
        v-if="
          searchCondition.storeOrShopIds &&
          searchCondition.storeOrShopIds.length > 0
        "
        @click="deleteShops"
      >
        清空
      </div>
  
      <div
        v-else
        style="
          display: flex;
          flex-flow: row nowrap;
          justify-content: flex-start;
          align-items: center;
          width: 80px;
          cursor: pointer;
        "
        @click="openVisible"
      >
        <img
          style="width: 16px; height: 16px; margin-right: 6px"
          class="avatar"
          src="@/assets/shaixuan.png"
          alt=""
        />
        <div style="font-size: 14px; color: #909399; margin-right: 10px">
          筛选
        </div>
      </div>
      <el-dialog
        :close-on-click-modal="false"
        title="选择门店"
        width="1600px"
        :before-close="qx"
        :visible.sync="storeVisible"
      >
        <div class="flex">
          <div class="mr10" style="width: 600px">
            <div class="table-panel flex flex-between">
              <div class="fr" style="width: 100%">
                <el-button
                  class="fr"
                  style="margin-right: 10px"
                  type="primary"
                  size="small"
                  @click="storeSearch"
                  >查询</el-button
                >
                <el-input
                  clearable
                  v-model.trim="storesNames"
                  placeholder="请输入商户"
                  size="small"
                  class="ipt mr10 fr"
                >
                </el-input>
              </div>
            </div>
            <div class="table-panel">
              <div class="tables">
                <el-table
                  stripe
                  ref="roleTable"
                  :data="storeBasucList.records"
                  style="width: 100%"
                  id="table"
                  @row-click="tableSelect"
                  size="small"
                  border
                  max-height="500"
                  @selection-change="handleSelectionChange"
                >
                  <el-table-column
                    type="selection"
                    header-align="center"
                    align="center"
                    width="50"
                  >
                  </el-table-column>
                  <el-table-column
                    type="index"
                    label="序号"
                    align="center"
                    :index="
                      (index) =>
                        index + (storeCurrentPage - 1) * storePageSize + 1
                    "
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="storeName"
                    label="商户"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="shopCount"
                    width="90"
                    label="门店数"
                  ></el-table-column>
                </el-table>
              </div>
              <div class="hm-pagination">
                <el-pagination
                  background
                  small
                  :pager-count="5"
                  :total="storeBasucList.total"
                  @current-change="storePaging"
                  :page-size="storePageSize"
                  @size-change="storeHandleSizeChange"
                  layout="total,sizes,  prev, pager, next, jumper"
                  :current-page="storeCurrentPage"
                ></el-pagination>
              </div>
            </div>
          </div>
          <div class="mar10 seach_checked">
            <el-button
              class="btn"
              type="primary"
              size="small"
              @click="searchShop"
              >查询勾选商户门店</el-button
            >
          </div>
          <div class="mr10 w60" style="width: 800px">
            <div class="table-panel flex flex-between">
              <div class="fr">
                <el-input
                  clearable
                  v-model.trim="shopName"
                  placeholder="请输入门店名称"
                  size="small"
                  class="ipt mr10"
                ></el-input>
                <el-button type="primary" size="small" @click="shopSearch"
                  >查询</el-button
                >
              </div>
            </div>
            <div class="table-panel">
              <div class="table">
                <el-table
                  stripe
                  ref="rightData"
                  :data="notRelShopList.records"
                  style="width: 100%"
                  id="table"
                  size="small"
                  @row-click="rightTableSelect"
                  @selection-change="getShopChecked"
                  border
                  max-height="500"
                >
                  <el-table-column type="selection"></el-table-column>
                  <el-table-column
                    type="index"
                    label="序号"
                    :index="
                      (index) =>
                        index + (shopCurrentPage - 1) * shopPageSize + 1
                    "
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    prop="storeName"
                    label="商户"
                  ></el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    width="150"
                    prop="shopName"
                    label="门店名称"
                  >
                    <template slot-scope="scope">
                      <div class="flex item-center">
                        <span>{{ scope.row.shopName }}</span>
                        <span
                          v-if="scope.row.shopMonthlyStatementFlag"
                          class="monthlyStatement-wrapper"
                          >月结</span
                        >
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    label="所在省/市/区"
                    prop="citys"
                  >
                    <template slot-scope="scope">
                      <div>
                        {{ scope.row.provinceName }}{{ scope.row.cityName
                        }}{{ scope.row.districtName }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    label="详细地址"
                    prop="shopAddress"
                  >
                  </el-table-column>
                  <el-table-column
                    header-align="center"
                    align="center"
                    label="组织机构代码"
                    prop="orgCode"
                  >
                  </el-table-column>
                </el-table>
              </div>
              <div class="hm-pagination">
                <el-pagination
                  small
                  background
                  :total="notRelShopList.total"
                  @current-change="shopPaging"
                  :page-size="shopPageSize"
                  @size-change="shopHandleSizeChange"
                  layout="total,sizes, prev, pager, next, jumper"
                  :current-page="shopCurrentPage"
                ></el-pagination>
              </div>
            </div>
          </div>
        </div>
        <div class="btn-wrapper flex flex-center">
          <el-button size="small" type="primary" @click="submitAllStore()"
            >确 定</el-button
          >
          <el-button size="small" @click="qx">取 消</el-button>
        </div>
      </el-dialog>

      <el-select
        v-if="searchCondition.status === 'goods'"
        size="small"
        clearable
        placeholder="选择品牌"
        v-model="searchCondition.brandNameList"
        class="mr10"
        filterable
        multiple
      >
        <el-option
          v-for="(item, i) in allBrankList"
          :key="i"
          :label="item.brandName"
          :value="item.brandName"
        ></el-option>
      </el-select>
      <el-input
        v-if="searchCondition.status === 'goods'"
        clearable
        v-model.trim="searchCondition.goodsKeyWords"
        placeholder="请输入商品名/货号/条码"
        size="small"
        class="mr10"
        style="width: 200px"
      ></el-input>

      <el-select
         v-if="
          searchCondition.status === 'tiXian' ||
          searchCondition.status === 'daoGou' ||
          searchCondition.status === 'mingxi' ||
          searchCondition.status === 'menDian'||
          searchCondition.status === 'goods'||
          searchCondition.status === 'mingxiNew'
        "
        style="width: 200px; margin-right: 15px"
        v-model="searchCondition.rewardRuleId"
        filterable
        remote
        reserve-keyword
        clearable
        size="small"
        placeholder="请输入活动名称"
        :remote-method="remoteMethod"
        :loading="activityLoading">
        <el-option
          v-for="item in activityOptions"
          :key="item.value"
          :label="item.rewardName"
          :value="item.rewardRuleId">
        </el-option>
      </el-select>




      <el-input
        v-if="
          searchCondition.status === 'tiXian' ||
          searchCondition.status === 'daoGou' ||
          searchCondition.status === 'mingxi' ||
          searchCondition.status === 'storeShare'||
          searchCondition.status === 'mingxiNew'
        "
        clearable
        v-model.trim="searchCondition.keyWords"
        placeholder="请输入手机号"
        size="small"
        style="width: 270px"
        class="mr10"
      ></el-input>

      <el-cascader
        class="mr10"
        :options="area"
        size="small"
        v-if="
          searchCondition.status === 'menDian' ||
          searchCondition.status === 'daoGou'
        "
        ref="citys"
        clearable
        placeholder="请选择省市区"
        v-model="searchCondition.citys"
        :props="propsCity"
      >
      </el-cascader>
      <el-select
        v-model="searchCondition.queryTimeType"
        size="small"
        style="width: 101px; margin-left: 4px"
        class="time-type"
        filterable
      >
        <el-option label="扣费时间" value="deduction"></el-option>
        <el-option
          v-if="searchCondition.status !== 'storeShare'"
          :label="searchCondition.status === 'refund'?'退款时间':'小票时间'"
          :value="searchCondition.status === 'refund'?'refundTime':'receipts'"
        ></el-option>
      </el-select>
      <el-date-picker
        :default-time="['00:00:00', '23:59:59']"
        class="mr10 time"
        size="small"
        value-format="yyyy-MM-dd HH:mm:ss"
        v-model="searchCondition.receiptDate"
        type="datetimerange"
        range-separator="至"
        start-placeholder="选择小票时间时间段"
        end-placeholder="选择小票时间时间段"
      ></el-date-picker>
      <el-select
        v-if="searchCondition.status === 'daoGou'"
        size="small"
        clearable
        placeholder="选择门店"
        v-model="searchCondition.shopIds"
        class="mr10"
        filterable
        multiple
        style="width: 200px"
      >
        <el-option
          v-for="(item, i) in redpackageOutletRelList"
          :key="i"
          :label="item.shopName"
          :value="item.shopId"
        ></el-option>
      </el-select>
      <div class="flex item-center mr10 pointer ml10" @click="drawer = true">
        <div class="more-search">更多筛选</div>
        <div>
          <i class="el-icon-arrow-right"></i>
        </div>
      </div>
      <el-button type="primary" size="small" @click="search">查询</el-button>
      <el-button
        type="success"
        size="small"
        @click="output1"
        :loading="isOutputing"
        >导出</el-button
      >
    </div>

    <hm-content
      title=""
      ref="hmcontent"
      style="position: relative; padding-botttom: 0"
    >
      <el-table
        :data="tableData"
        style="width: 100%"
        ref="goods"
        stripe
        border
        size="small"
      >
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          :index="(index) => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          :prop="item.prop"
          :label="item.label"
          :column-key="item.prop"
          v-for="(item, index) in configProps"
          v-if="item.isChecked"
          :key="index"
        >
          <template
            v-slot:default="scope"
            v-if="
              item.prop == 'declareSn' ||
              item.prop == 'feeMoney' ||
              item.prop == 'afterBalance' ||
              item.prop == 'declareImg' ||
              item.prop == 'guiderProfitAmount' ||
              item.prop == 'feeAmount'
            "
          >
            <div
              class="blue pointer"
              @click="viewDetails(scope.row.declareSn)"
              v-if="item.prop == 'declareSn'"
            >
              {{ scope.row.declareSn }}
            </div>
            <span class="primary" v-else-if="item.prop == 'guiderProfitAmount'"
              >￥{{ scope.row.guiderProfitAmount }}</span
            >
            <span class="primary" v-else-if="item.prop == 'feeMoney'"
              >￥{{ scope.row.feeMoney }}</span
            >
            <div class="primary" v-else-if="item.prop == 'afterBalance'">
              ¥{{ scope.row.afterBalance }}
            </div>
            <div v-else-if="item.prop == 'feeAmount'">
              ¥{{ scope.row.feeAmount }}
            </div>
            <div class="flex flex-center" v-else-if="item.prop == 'declareImg'">
              <el-image
                style="width: 100px; height: 100px"
                :src="scope.row.declareImgList[0]"
                :preview-src-list="scope.row.declareImgList"
              ></el-image>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          :page-size="pageSize"
          @size-change="handleSizeChange"
          layout="total,sizes,  prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
      <div
        class="table-options flex flex-center item-center"
        @click="tableSetVisible = true"
      >
        <span class="table-options-text">表头配置</span>
        <span class="hmicon icon-icon-youjiantou"></span>
      </div>
      <!-- 添加表头配置弹窗 -->
      <div class="table-set-popup" v-if="tableSetVisible" title="添加表头">
        <div class="table-set-tit">添加表头</div>
        <div
          class="table-set-close hmicon icon-guanbi1"
          @click="tableSetVisible = false"
        ></div>
        <div>
          <el-checkbox
            v-model="v.isChecked"
            style="display: block; margin-bottom: 20px"
            :label="v.label"
            v-for="(v, i) in configProps"
            :key="i"
            >{{ v.label }}
          </el-checkbox>
        </div>
      </div>
    </hm-content>

    <el-drawer
      title="更多筛选"
      :visible.sync="drawer"
      direction="rtl"
      size="730px"
    >
      <div class="drawer-search shop-list">
        <div class="flex flex-wrap">
          <el-cascader
            clearable
            class="mr10 mb10"
            ref="cascader"
            v-model="searchCondition.storeOrShopIds"
            :props="props"
            filterable
            :show-all-levels="false"
            size="small"
            placeholder="请选择商户"
          ></el-cascader>
          <el-select
            v-if="searchCondition.status === 'goods'"
            size="small"
            clearable
            placeholder="选择品牌"
            v-model="searchCondition.brandNameList"
            class="mr10 mb10"
            filterable
            multiple
          >
            <el-option
              v-for="(item, i) in allBrankList"
              :key="i"
              :label="item.brandName"
              :value="item.brandName"
            ></el-option>
          </el-select>
          <el-input
            v-if="searchCondition.status === 'goods'"
            clearable
            v-model.trim="searchCondition.goodsKeyWords"
            placeholder="请输入商品名/货号/条码"
            size="small"
            class="mr10 mb10"
            style="width: 200px"
          ></el-input>
          <el-input
            v-if="
              searchCondition.status === 'tiXian' ||
              searchCondition.status === 'daoGou' ||
              searchCondition.status === 'mingxi' ||
              searchCondition.status === 'storeShare' ||
              searchCondition.status === 'mingxiNew'
            "
            clearable
            v-model.trim="searchCondition.keyWords"
            placeholder="请输入导购名称/手机号"
            size="small"
            style="width: 200px"
            class="mr10"
          ></el-input>
          <el-cascader
            class="mr10 mb10"
            :options="area"
            size="small"
            v-if="
              searchCondition.status === 'menDian' ||
              searchCondition.status === 'daoGou'
            "
            ref="citys"
            clearable
            placeholder="请选择省市区"
            v-model="searchCondition.citys"
            :props="propsCity"
          >
          </el-cascader>
          <el-select
            v-if="searchCondition.status === 'daoGou'"
            size="small"
            clearable
            placeholder="选择门店"
            v-model="searchCondition.shopIds"
            class="mr10 mb10"
            filterable
            multiple
            style="width: 200px"
          >
            <el-option
              v-for="(item, i) in redpackageOutletRelList"
              :key="i"
              :label="item.shopName"
              :value="item.shopId"
            ></el-option>
          </el-select>
        </div>

        <div class="mb10">
          <el-select
            v-model="searchCondition.queryTimeType"
            size="small"
            style="width: 101px; margin-left: 4px"
            class="time-type"
            filterable
          >
            <el-option label="扣费时间" value="deduction"></el-option>
            <el-option
              v-if="searchCondition.status !== 'storeShare'"
              :label="searchCondition.status === 'refund'?'退款时间':'小票时间'"
              :value="searchCondition.status === 'refund'?'refundTime':'receipts'"
            ></el-option>
          </el-select>
          <el-date-picker
            :default-time="['00:00:00', '23:59:59']"
            class="mr10 time"
            size="small"
            value-format="yyyy-MM-dd HH:mm:ss"
            v-model="searchCondition.receiptDate"
            type="datetimerange"
            range-separator="至"
            start-placeholder="选择小票时间时间段"
            end-placeholder="选择小票时间时间段"
          ></el-date-picker>
        </div>

        <div class="flex flex-end">
          <el-button type="primary" size="small" @click="search"
            >查询</el-button
          >
          <el-button
            type="success"
            size="small"
            @click="output1"
            :loading="isOutputing"
            >导出</el-button
          >
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getLoginUser, getUserName } from "@/utils/auth";
import area from "@/utils/area";
import moment from "moment";
import { truncateToTwoDecimalPlaces } from "@/utils/utils";
export default {
  components: {},
  data() {
    return {
      drawer: false,
      area,
      propsCity: {
        value: "value",
        children: "children",
      },
      props: {
        lazy: true,
        checkStrictly: true,
        multiple: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryStoreBasicInfoTree", {
                pageNo: 1,
                pageSize: 999,
                supplierCode: this.$route.query.storeCode,
              })
              .then((res) => {
                res.result.forEach((v) => {
                  v.leaf = Boolean(v.shopCount > 0 ? false : true);
                  v.value = v.storeCode;
                  v.label = v.storeName;
                });
                resolve(res.result);
              });
          } else if (level === 1) {
            this.$store
              .dispatch("queryStoreShopInfoTree", {
                storeCode: data.storeCode,
              })
              .then((res) => {
                if (res.code === "0" && res.result) {
                  res.result.forEach((v) => {
                    v.leaf = true;
                    v.value = v.shopId;
                    v.label = v.shopName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          } else {
            resolve([]);
          }
        },
      },
      activityLoading: false,
      activityOptions:[],
      searchCondition: {
        status: "tiXian",
        rewardRuleId:'',
        rewardRuleIdList:[],
        queryTimeType: "deduction",
        keyWords: "",
        receiptDate: [],
      },
      num: 0,
      storeNames: "",
      isOutputing: false,
      goodsReportList: {},
      reportListGroup: [],
      reportListGroupTotal: 0,
      allBrankList: [],
      redpackageOutletRelList: [],
      storeShareList: [],
      storeShareListTotal: 0,

      // 自定义报表字段 2024-6-15
      tableSetVisible: false,
      reportList: "",
      currentPage: 1,
      pageSize: 10,
      total: 0,
      configProps: [],
      tableData: [],

      // 选择商户优化 2024-6-15
      storeVisible: false,
      storeCurrentPage: 1,
      storePageSize: 10,
      storesNames: "",
      storeCodeList: [],
      shopCurrentPage: 1,
      shopName: "",
      shopPageSize: 10,
      allOptions: [],
      selectedOptions: [],
      storeOrShopIds: [],
    };
  },
  computed: mapGetters([
    "commissionReportList",
    "shopReportList",
    "guiderReportList",
    "allCommissionReportList",

    // 2024-6-17
    "storeBasucList",
    "notRelShopList",
  ]),
  watch: {
    $route() {
      this.storeNames = localStorage.getItem("storeName");
      this.$store.dispatch("clearCommissionReportList");
      this.goodsReportList = {};
      this.storeShareList = {};
      this.reportListGroup = {};
    },
  },
  created() {},
  mounted() {
    this.searchCondition.rewardRuleId = '';
    const startTime = moment().startOf("day").format("YYYY-MM-DD HH:mm:ss");
    const endTime = moment().endOf("day").format("YYYY-MM-DD HH:mm:ss");
    this.searchCondition.receiptDate = [startTime, endTime];
    this.queryAllBrand();
    this.storeNames = localStorage.getItem("storeName");
    this.getQuerySsrBasicConfig();
  },
  methods: {
    async remoteMethod(query) {
      console.log(query);
      if (query !== '') {
        const { result, code } = await this.$store.dispatch(
          "queryActivityQueryPageList",
          {
            supplierCode: this.$route.query.storeCode,
            rewardName: query
          }
        );
        console.log(result);

        this.activityOptions = result.records;


      } else {
        this.activityOptions = [];
      }
    },
    async queryStoreShareList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        supplierCode: this.$route.query.storeCode,
      };


      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.storeOrShopIds.forEach((v) => {
        if(v.length > 0){
          v = v[1]
        }
      });

      console.log("searchCondition", searchCondition)

      this.queryTime(searchCondition);
      Object.assign(params, searchCondition);
      const { result, code } = await this.$store.dispatch(
        "queryStoreShareManageList",
        params
      );
      if (code === "0") {
        const { records, total } = result;
        this.storeShareList = records;
        this.storeShareList.forEach((v) => {
          if (v.declareImg) {
            v.declareImgList = v.declareImg.split(",");
          } else {
            v.declareImgList = [""];
          }
        });
        console.log("storeShareList", this.storeShareList);
        this.storeShareListTotal = total;
      }
    },
    async queryRedpackageOutletRelList() {
      let params = {
        pageSize: 99999,
        pageNo: 1,
        storeCode: this.$route.query.storeCode,
      };
      const { code, result } = await this.$store.dispatch(
        "queryRedpackageOutletRelList",
        params
      );
      if (code === "0") {
        this.redpackageOutletRelList = result.records;
      }
    },
    async queryAllBrand() {
      const { result, code } = await this.$store.dispatch(
        "queryHemiaoBrandComboBox",
        {
          supplierCode: this.$route.query.storeCode,
        }
      );
      if (code === "0") {
        this.allBrankList = result;
      }
    },
    // "tiXian">申报明细</el-radio-button>
    //       <el-radio-button label="menDian">门店统计</el-radio-button>
    //       <el-radio-button label="daoGou
    async switchTab(val) {
      if (this.searchCondition.queryTimeType == "receipts" && this.searchCondition.status === "refund") {
        this.searchCondition.queryTimeType = "deduction";
      }
      if (this.searchCondition.queryTimeType == "refundTime" && this.searchCondition.status !== "refund") {
        this.searchCondition.queryTimeType = "deduction";
      }
      if (this.searchCondition.status === "storeShare") {
        this.searchCondition.queryTimeType = "deduction";
      }
      console.log(this.searchCondition.queryTimeType);
      await this.getQuerySsrBasicConfig();
      this.searchCondition.keyWords = "";
      this.goodsReportList.records = [];
      this.goodsReportList.total = 0;

      this.commissionReportList.records = [];
      this.commissionReportList.total = 0;

      this.shopReportList.records = [];
      this.shopReportList.total = 0;

      this.guiderReportList.records = [];
      this.guiderReportList.total = 0;

      this.reportListGroup = [];
      this.reportListGroupTotal = 0;

      this.storeShareList = [];
      this.storeShareListTotal = 0;
      this.tableData = [];
      this.$nextTick(() => {
        // let name = JSON.parse(JSON.stringify(val));
        // this.$refs[name.toLowerCase()].doLayout();
        //给table加一个ref
      });
      if (
        this.searchCondition.receiptDate &&
        this.searchCondition.receiptDate.length > 0
      ) {
        this.currentPage = 1;
        this.pageSize = 10;
        this.checkedRow = [];
        this.querynewList();
      } else {
        this.$message({
          message: "请选择小票时间段!",
          type: "warning",
        });
      }
    },
    searchEs() {
      if (
        this.searchCondition.receiptDate &&
        this.searchCondition.receiptDate.length > 0
      ) {
        if (this.searchCondition.status === "tiXian") {
          this.currentPage = 1;
          // this.queryListEs();
          this.queryListnewEs();
        } else if (this.searchCondition.status === "menDian") {
          this.currentPage = 1;
          this.queryShopList();
        } else if (this.searchCondition.status === "daoGou") {
          this.currentPage = 1;
          this.queryGuiderList();
        } else if (this.searchCondition.status === "goods") {
          this.currentPage = 1;
          this.obtainDeclareGoodsDetailsEs();
        } else if (this.searchCondition.status === "mingxi") {
          this.currentPage = 1;
          this.queryReportListGroup1();
        } else if (this.searchCondition.status === "storeShare") {
          this.currentPage = 1;
          this.queryStoreShareList();
        }
      } else {
        this.$message({
          message: "请选择时间段!",
          type: "warning",
        });
      }
    },
    searchMysql() {
      if (
        this.searchCondition.receiptDate &&
        this.searchCondition.receiptDate.length > 0
      ) {
        if (this.searchCondition.status === "tiXian") {
          this.currentPage = 1;
          this.queryListMysql();
        } else if (this.searchCondition.status === "menDian") {
          this.currentPage = 1;
          this.queryShopList();
        } else if (this.searchCondition.status === "daoGou") {
          this.currentPage = 1;
          this.queryGuiderList();
        } else if (this.searchCondition.status === "goods") {
          this.currentPage = 1;
          this.queryGoodsList();
        } else if (this.searchCondition.status === "mingxi") {
          this.currentPage = 1;
          this.queryReportListGroup1();
        } else if (this.searchCondition.status === "storeShare") {
          this.currentPage = 1;
          this.queryStoreShareList();
        }
      } else {
        this.$message({
          message: "请选择时间段!",
          type: "warning",
        });
      }
    },
    search() {
      if (
        this.searchCondition.receiptDate &&
        this.searchCondition.receiptDate.length > 0
      ) {
        // if (this.searchCondition.status === "tiXian") {
        //   this.currentPage = 1;
        //   this.queryList();
        // } else if (this.searchCondition.status === "menDian") {
        //   this.currentPage = 1;
        //   this.queryShopList();
        // } else if (this.searchCondition.status === "daoGou") {
        //   this.currentPage = 1;
        //   this.queryGuiderList();
        // } else if (this.searchCondition.status === "goods") {
        //   this.currentPage = 1;
        //   this.queryGoodsList();
        // } else if (this.searchCondition.status === "mingxi") {
        //   this.currentPage = 1;
        //   this.queryReportListGroup();
        // } else if (this.searchCondition.status === "storeShare") {
        //   this.currentPage = 1;
        //   this.queryStoreShareList();
        // }
        this.currentPage = 1;
        this.querynewList();
      } else {
        this.$message({
          message: "请选择时间段!",
          type: "warning",
        });
      }
    },
    paging(page) {
      this.currentPage = page;
      this.querynewList();
    },
    queryTime(searchCondition) {
      if (this.searchCondition.queryTimeType === "deduction") {
        searchCondition.tradeTimeStart =
          this.searchCondition.receiptDate &&
          this.searchCondition.receiptDate.length > 0
            ? this.searchCondition.receiptDate[0]
            : "";
        searchCondition.tradeTimeEnd =
          this.searchCondition.receiptDate &&
          this.searchCondition.receiptDate.length > 0
            ? this.searchCondition.receiptDate[1]
            : "";
        searchCondition.receiptStartDate = "";
        searchCondition.receiptEndDate = "";
        return searchCondition;
      } else {
        searchCondition.receiptStartDate =
          this.searchCondition.receiptDate &&
          this.searchCondition.receiptDate.length > 0
            ? this.searchCondition.receiptDate[0]
            : "";
        searchCondition.receiptEndDate =
          this.searchCondition.receiptDate &&
          this.searchCondition.receiptDate.length > 0
            ? this.searchCondition.receiptDate[1]
            : "";
        searchCondition.tradeTimeStart = "";
        searchCondition.tradeTimeEnd = "";
        return searchCondition;
      }
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.querynewList();
    },
    async queryReportListGroup() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        supplierCode: this.$route.query.storeCode,
      };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      this.queryTime(searchCondition);
      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch(
        "findCommissionReportListGroupByReward",
        params
      );
      if (code === "0") {
        const { records, total } = result;
        this.reportListGroup = records;
        this.reportListGroupTotal = total;
      }
    },
    queryListEs() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        supplierCode: this.$route.query.storeCode,
      };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      this.queryTime(searchCondition);
      Object.assign(params, searchCondition);
      return this.$store.dispatch("obtainDeclareBillDetailsEs", params);
    },
    queryListnewEs() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        supplierCode: this.$route.query.storeCode,
      };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      this.queryTime(searchCondition);
      Object.assign(params, searchCondition);
      return this.$store.dispatch("newobtainDeclareBillDetailsEs", params);
    },
    queryListMysql() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        supplierCode: this.$route.query.storeCode,
      };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      this.queryTime(searchCondition);
      Object.assign(params, searchCondition);
      return this.$store.dispatch("obtainDeclareBillDetailsMysql", params);
    },
    queryList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        supplierCode: this.$route.query.storeCode,
      };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      this.queryTime(searchCondition);
      Object.assign(params, searchCondition);
      return this.$store.dispatch("queryCommissionReportList", params);
    },

    async obtainDeclareGoodsDetailsEs() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        supplierCode: this.$route.query.storeCode,
      };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      this.queryTime(searchCondition);
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
        "obtainDeclareGoodsDetailsEs",
        params
      );
      this.goodsReportList = result;
    },
    queryShopList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        supplierCode: this.$route.query.storeCode,
      };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      if (typeof searchCondition.citys === "object") {
        searchCondition.shopProvinceCode = searchCondition.citys[0];
        searchCondition.shopCityCode = searchCondition.citys[1];
        searchCondition.shopDistrictCode = searchCondition.citys[2];
      }
      this.queryTime(searchCondition);
      Object.assign(params, searchCondition);
      return this.$store.dispatch("queryShopReportList", params);
    },
    queryGuiderList() {
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        supplierCode: this.$route.query.storeCode,
      };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      if (typeof searchCondition.citys === "object") {
        searchCondition.shopProvinceCode = searchCondition.citys[0];
        searchCondition.shopCityCode = searchCondition.citys[1];
        searchCondition.shopDistrictCode = searchCondition.citys[2];
      }
      this.queryTime(searchCondition);
      Object.assign(params, searchCondition);
      return this.$store.dispatch("queryGuiderReportList", params);
    },
    async queryAllGoodsList() {
      let params = {
        pageNo: 1,
        pageSize: 999999,
        supplierCode: this.$route.query.storeCode,
      };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      this.queryTime(searchCondition);
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
        "queryAllGoodsReportList",
        params
      );
      return result;
    },
    queryAllList() {
      let params = {
        pageNo: 1,
        pageSize: 999999,
        supplierCode: this.$route.query.storeCode,
      };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      this.queryTime(searchCondition);
      Object.assign(params, searchCondition);
      return this.$store.dispatch("queryAllCommissionReportList", params);
    },
    async queryAllReportListGroup() {
      let params = {
        pageNo: 1,
        pageSize: 999999,
        supplierCode: this.$route.query.storeCode,
      };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      this.queryTime(searchCondition);
      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch(
        "findAllCommissionReportListGroupByReward",
        params
      );
      if (code === "0") {
        const { records } = result;
        return records;
      }
    },
    queryAllShopList() {
      let params = {
        pageNo: 1,
        pageSize: 999999,
        supplierCode: this.$route.query.storeCode,
      };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      if (typeof searchCondition.citys === "object") {
        searchCondition.shopProvinceCode = searchCondition.citys[0];
        searchCondition.shopCityCode = searchCondition.citys[1];
        searchCondition.shopDistrictCode = searchCondition.citys[2];
      }
      this.queryTime(searchCondition);
      Object.assign(params, searchCondition);
      return this.$store.dispatch("queryAllShopReportList", params);
    },
    queryAllGuiderList() {
      let params = {
        pageNo: 1,
        pageSize: 999999,
        supplierCode: this.$route.query.storeCode,
      };

      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      if (typeof searchCondition.citys === "object") {
        searchCondition.shopProvinceCode = searchCondition.citys[0];
        searchCondition.shopCityCode = searchCondition.citys[1];
        searchCondition.shopDistrictCode = searchCondition.citys[2];
      }
      this.queryTime(searchCondition);
      Object.assign(params, searchCondition);
      return this.$store.dispatch("queryAllGuiderReportList", params);
    },
    viewDetails(declareSn) {
      let routeData = this.$router.resolve({
        name: "DetailsSalesVolumeNew",
        query: { declareSn },
      });
      window.open(routeData.href, "_blank");
    },
    
    // 导出excel
    async output1() {
      let params = {
        supplierCode: this.$route.query.storeCode,
        operUsername: getUserName(),
        supplierName: localStorage.getItem("storeName") || this.storeNames,
      };
      let searchCondition = JSON.parse(JSON.stringify(this.searchCondition));

      let storeCodeList = [];
      let shopIdList = [];
      if(searchCondition.storeOrShopIds && searchCondition.storeOrShopIds.length > 0){
        searchCondition.storeOrShopIds.forEach((v) => {
          storeCodeList.push(v[0]);
          shopIdList.push(v[1]);
        });
      }
      searchCondition.storeCodeList = storeCodeList;
      searchCondition.shopIdList = shopIdList;
      console.log(searchCondition)
      this.queryTime(searchCondition);
      Object.assign(params, searchCondition);

      if (this.searchCondition.status === "goods") {
        await this.$store.dispatch("exportDeclareGoodsEs", params);
      } else if (this.searchCondition.status === "tiXian") {
        // await this.$store.dispatch("exportDeclareBillDetailsEs", params);
        await this.$store.dispatch("exportDeclareBillEs", params);
      } else if (this.searchCondition.status === "menDian") {
        await this.$store.dispatch("exportShopEs", params);
      } else if (this.searchCondition.status === "daoGou") {
        await this.$store.dispatch("exportGuiderEs", params);
      } else if (this.searchCondition.status === "mingxi") {
        await this.$store.dispatch("exportBrandEs", params);
      } else if (this.searchCondition.status === "storeShare") {
        await this.$store.dispatch("exportShareEs", params);
      } else if (this.searchCondition.status === "refund") {
        await this.$store.dispatch("exportRefundEs", params);
      } else if (this.searchCondition.status === "mingxiNew") {
        await this.$store.dispatch("exportBrandDetailsEs", params);
      }else if (this.searchCondition.status === "refundCommodity") {
        await this.$store.dispatch("exportGoodsRefundEs", params);
      }
      setTimeout(() => {
        this.$message({
          message: "已加入导出队列正在生成报表，请在导出列队中查看！",
          type: "success",
        });
        this.$refs.hmcontent.flag = false;
      }, 0);
    },
    // 导出excel
    async output() {
      let params = {
        supplierCode: this.$route.query.storeCode,
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      this.queryTime(searchCondition);
      Object.assign(params, searchCondition);
      if (this.searchCondition.status === "goods") {
        await this.$store.dispatch("redpackageGoodsReportList", params);
      } else if (this.searchCondition.status === "tiXian") {
        await this.$store.dispatch("redpackageCommissionReportList", params);
      } else if (this.searchCondition.status === "menDian") {
        await this.$store.dispatch("redpackageShopReportList", params);
      } else if (this.searchCondition.status === "daoGou") {
        await this.$store.dispatch("redpackageGuiderReportList", params);
      } else if (this.searchCondition.status === "mingxi") {
        await this.$store.dispatch(
          "redpackageCommissionReportListGroupByReward",
          params
        );
      } else if (this.searchCondition.status === "storeShare") {
        await this.$store.dispatch("redpackageStoreShareListOutput", params);
      }
      setTimeout(() => {
        this.$message({
          message: "已加入导出队列正在生成报表，请在导出列队中查看！",
          type: "success",
        });
        this.$refs.hmcontent.flag = false;
      }, 0);
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    // 自定义报表修改2024-6-15
    // 获取列表配置字段
    async getQuerySsrBasicConfig() {
      let reportCode = "";
      this.configProps = [];
      if (this.searchCondition.status === "tiXian") {
        reportCode = "SUPPLIER_REPORT_BASIC_DELACRE_BILL";
      } else if (this.searchCondition.status === "menDian") {
        reportCode = "SUPPLIER_REPORT_BASIC_SHOP";
      } else if (this.searchCondition.status === "daoGou") {
        reportCode = "SUPPLIER_REPORT_BASIC_GUIDER";
      } else if (this.searchCondition.status === "goods") {
        reportCode = "SUPPLIER_REPORT_BASIC_GOODS";
      } else if (this.searchCondition.status === "mingxi") {
        reportCode = "SUPPLIER_REPORT_BASIC_BRAND";
      } else if (this.searchCondition.status === "storeShare") {
        reportCode = "SUPPLIER_REPORT_BASIC_SHARE";
      } else if (this.searchCondition.status === "refund" || this.searchCondition.status === "refundCommodity") {
        reportCode = "SUPPLIER_REPORT_BASIC_REFUND";
      } else if (this.searchCondition.status === "mingxiNew") {
        reportCode = "SUPPLIER_REPORT_BASIC_BRAND_DETAILS";
      }
      let params = {
        reportCode: reportCode,
      };
      const { result } = await this.$store.dispatch(
        "querySsrBasicConfig",
        params
      );
      if (result.ssrColumnsConfigModelList.length > 0) {
        result.ssrColumnsConfigModelList.forEach((item) => {
          let obj = {
            prop: item.columnName,
            label: item.labelName,
            isChecked: item.isSelectColumn == "yes" ? true : false,
          };
          this.configProps.push(obj);
        });
      }
      console.log(this.configProps);
    },
    async querynewList() {
      let methodName = "";
      if (this.searchCondition.status === "tiXian") {
        methodName = "obtainDeclareBillEs";
      } else if (this.searchCondition.status === "menDian") {
        methodName = "obtainShopEs";
      } else if (this.searchCondition.status === "daoGou") {
        methodName = "obtainGuiderEs";
      } else if (this.searchCondition.status === "goods") {
        methodName = "obtainDeclareGoodsEs";
      } else if (this.searchCondition.status === "mingxi") {
        methodName = "obtainBrandEs";
      } else if (this.searchCondition.status === "storeShare") {
        methodName = "obtainShareEs";
      } else if (this.searchCondition.status === "refund") {
        methodName = "obtainRefundEs";
      } else if (this.searchCondition.status === "mingxiNew") {
        methodName = "obtainBrandDetailsEs";
      }else if (this.searchCondition.status === "refundCommodity") {
        methodName = "obtainGoodsRefundEs";
      }

      console.log(1111);
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        supplierCode: this.$route.query.storeCode,
      };

      if(this.searchCondition.rewardRuleId) {
        this.searchCondition.rewardRuleIdList = [this.searchCondition.rewardRuleId];
      }else {
        this.searchCondition.rewardRuleIdList = [];
      }

      let searchCondition = JSON.parse(JSON.stringify(this.searchCondition));

      let storeCodeList = [];
      let shopIdList = [];
      if(searchCondition.storeOrShopIds && searchCondition.storeOrShopIds.length > 0){
        searchCondition.storeOrShopIds.forEach((v) => {
          storeCodeList.push(v[0]);
          shopIdList.push(v[1]);
        });
      }

      searchCondition.storeCodeList = storeCodeList;
      searchCondition.shopIdList = shopIdList;

      this.queryTime(searchCondition);
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(methodName, params);
      console.log(result);
      this.tableData = result.records;
      // if (result.records.length>0) {
      //   let obj = [];
      //   result.records.forEach(() => {
      //     obj.push([]);
      //   });
      //   this.configProps.forEach((item1, index1) => {
      //     result.records.forEach((item2, index2) => {
      //       if (Object.keys(item2).includes(item1.prop)) {
      //         let obj1 = {};
      //         obj1["label"] = item1.label;
      //         obj1["prop"] = item1.prop;
      //         obj1["value"] = item2[item1.prop];
      //         obj1["isChecked"] = item1.isChecked;
      //         obj[index2].push(obj1);
      //       }
      //     });
      //     // reportList.push(obj)
      //   });
      //   this.reportList = obj;
      // }
      this.total = result.total;
      console.log(this.reportList);
      console.log("---------");
    },

    // 2024-6-15 选择商户优化
    openVisible() {
      this.storeVisible = true;
      this.notRelShopList.records = [];
      this.notRelShopList.total = 0;
      this.shopCurrentPage = 1;
      this.storePageSize = 10;
      this.shopPageSize = 10;
      this.queryStoreList();
    },
    storePaging(page) {
      this.storeCurrentPage = page;
      this.queryStoreList();
    },
    storeHandleSizeChange(size) {
      this.storeCurrentPage = 1;
      this.storePageSize = size;
      this.queryStoreList();
    },
    storeSearch() {
      this.storeCurrentPage = 1;
      this.queryStoreList();
    },
    // 获取一级商户列表
    queryStoreList() {
      let params = {
        pageSize: this.storePageSize,
        pageNo: this.storeCurrentPage,
        storeName: this.storesNames,
        queryRewardFlag: "exclude",
        queryRewardNumStat: "exclude",
        queryShopStat: "include",
        queryTemplateStat: "exclude",
        queryRiskeStat: "exclude",
      };
      this.$store.dispatch("queryStoreBasicList", params);
    },
    searchShop() {
      this.canClick = false;
      if (this.storeCodeList.length) {
        this.shopCurrentPage = 1;
        this.importData = false;
        // console.log("1", this.searchShopList());
        this.searchShopList();
      } else {
        this.$message({
          message: "请选择商户",
          type: "warning",
        });
      }
    },
    shopSearch() {
      this.shopCurrentPage = 1;
      this.searchShopList();
    },
    shopPaging(page) {
      this.shopCurrentPage = page;
      this.searchShopList();
    },
    shopHandleSizeChange(size) {
      this.shopCurrentPage = 1;
      this.shopPageSize = size;
      this.searchShopList();
    },
    searchShopList() {
      console.log(44444);
      let params = {
        pageSize: this.shopPageSize,
        pageNo: this.shopCurrentPage,
        shopName: this.shopName,
        storeCodeList: this.storeCodeList,
        supplierCode: this.$route.query.storeCode,
      };
      this.$store.dispatch("queryFindRelShopList", params);
    },
    //左边表格表格选中
    tableSelect(row) {
      this.$refs.roleTable.toggleRowSelection(row);
    },
    handleSelectionChange(row) {
      this.storeCodeList = row.map((v) => v.storeCode);
    },
    rest() {
      setTimeout(() => {
        this.departIds = "";
        this.storeCode = "";
        // this.storeName = "";
        this.shopName = "";
        this.storesNames = "";
        this.storeBasucList.records = [];
        this.storeBasucList.total = 0;
        this.notRelShopList.records = [];
        this.notRelShopList.total = 0;
      }, 0);
    },
    qx() {
      this.storeVisible = false;
      this.rest();
    },
    rightTableSelect(row, column) {
      if (column.label != "对应组织机构") {
        this.$refs.rightData.toggleRowSelection(row);
      }
    },
    getShopChecked(selection) {
      this.checkedShopRow = selection;
    },
    deleteShops() {
      this.searchCondition.storeOrShopIds = [];
      this.selectedOptions = "";
      this.storesNames = "";
    },

    submitAllStore() {
      if (this.checkedShopRow <= 0) {
        this.$message({
          message: "请选择",
          type: "warning",
        });
      } else {
        let arrs = [],
          subArrs = [],
          storeOrShopIds = [];
        this.checkedShopRow.forEach((v, index) => {
          let items = {
            label: v.shopName,
            value: v.shopCode,
            disabled: true,
          };
          let itemList = [];
          itemList[0] = v.storeCode;
          itemList[1] = v.shopId;
          arrs.push(items);
          if (index == 0) {
            subArrs.push(items.label);
          }
          // subArrs.push(items.label);
          // if (index == 0) {
          //   subArrs = `${subArrs}${v.shopName}`;
          // } else {
          //   subArrs = `${subArrs}, ${v.shopName}`;
          // }
          storeOrShopIds.push(itemList);
          if (v.departIds && v.departIds.length > 0) {
            v.departId = v.departIds[v.departIds.length - 1];
          }
        });
        this.allOptions = arrs;
        this.selectedOptions = subArrs;
        this.storeVisible = false;
        console.log(9999)
        console.log(storeOrShopIds)
        this.searchCondition.storeOrShopIds = storeOrShopIds;
        console.log(
          this.checkedShopRow,
          "提交后的数组",
          this.allOptions,
          this.selectedOptions
        );
      }
    },
    truncateToTwoDecimal(num){
      return truncateToTwoDecimalPlaces(num)
    }
  },
};
</script>
<style lang="scss" scoped>
.time-type {
  .el-input__inner {
    border-right: 0;
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
    color: #909399;
    background-color: rgb(245, 247, 250);
  }
}
.time {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
}
.more-search {
  width: 10px;
  margin-right: 6px;
  transform: scale(0.9);
  color: #aaaaaa;
  box-shadow: -2px 2px 4px 0px rgba(0, 0, 0, 0.06);
  padding-left: 6px;
}
.bgColor {
  background: #fff;
}
.table-panel {
  font-size: 12px;
  .line {
    color: #dcdfe6;
    margin: 0 5px;
  }
}
.drawer-search {
  padding: 32px;
}

// 表头颜色
.el-table__header .el-table th.el-table__cell.is-leaf {
  background: #f7f7f7 !important;
}
// 添加表头按钮
.table-options {
  position: absolute;
  right: 20px;
  top: 20px;
  width: 40px;
  // height: 92px;
  height: 74px;
  box-sizing: border-box;
  padding: 0 10px;
  background: #fff;
  font-size: 12px;
  border: 1px solid #f7f7f7;
  cursor: pointer;
  .table-options-text {
    width: 20px;
    color: #666666;
  }
  .icon-icon-youjiantou {
    font-size: 12px;
  }
}
.table-set-popup {
  position: absolute;
  right: 0;
  top: 0;
  width: 266px;
  height: 470px;
  overflow-y: scroll;
  padding: 15px 30px;
  background: #fff;
  z-index: 2;
  box-shadow: -6px 0px 8px 0px rgba(0, 0, 0, 0.08);
  .table-set-tit {
    font-weight: bold;
    font-size: 18px;
    margin-bottom: 20px;
  }
  .table-set-close {
    position: absolute;
    right: 10px;
    top: 10px;
    cursor: pointer;
  }
  .icon-guanbi1 {
    font-size: 18px;
  }
}
.icon-jiahao,
.icon-jianhao1 {
  font-size: 24px;
}
.icon-jiahao {
  color: #d22e66;
}
.icon-jianhao1 {
  color: #909398;
}
.seach_checked {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-flow: column nowrap;
    flex-flow: column nowrap;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    margin: 0 10px;
}
</style>
